import { SET_PERMISSIONS } from '@actions/types'

const initialState = {
  hasEngage: false,
  hasResources: false,
  hasSafewalk: false,
  hasTipping: false,
  permissionsSet: false
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case SET_PERMISSIONS:
    return {
      ...state,
      permissionsSet: true,
      ...payload
    }
  default:
    return state
  }
}

export default reducer
